import { Navigate, useParams } from 'react-router-dom';

import DsrFaqScreens, {
  dsrFaqHeaders,
} from '../../../app/src/screens/DsrFaq/Faqs.js';

import { DSR_FAQ_PATH } from '../navigation/paths.js';
import { SharedScreen } from './ScreenChrome.jsx';

// One Demand Side Response FAQ: the app's own screen for it (Faqs.js exports one
// per question), rendered in place through the components/common shim, so the
// question and its answer are the app's text. The URL carries the app's own
// 1-based numbering (its screens are DsrFaq1…DsrFaq12); anything that is not one
// of those goes back to the list.
export default function DsrFaqScreen() {
  const { index } = useParams();
  const number = Number(index);
  const valid =
    Number.isInteger(number) && number >= 1 && number <= dsrFaqHeaders.length;
  if (!valid) {
    return <Navigate to={DSR_FAQ_PATH} replace />;
  }
  const Screen = DsrFaqScreens[number - 1];
  return (
    <SharedScreen
      backTo={DSR_FAQ_PATH}
      backLabel="Demand Side Response"
      className="dsr-faq"
    >
      <Screen key={number} />
    </SharedScreen>
  );
}
